import { CreditLimitLevel, CustomerCreditBalance } from '../types/credit';

/** Assessment of the customer-only balance. Only the document-bound endpoint
    returns a `level`; before a document exists the same verdict has to be
    derived from the numbers. A limit of `0` means "not configured" and is
    therefore never checked. */
export function customerCreditLevel(
  balance: CustomerCreditBalance | null | undefined
): CreditLimitLevel | null {
  if (!balance) return null;
  if (balance.limit > 0 && balance.balance > balance.limit) return 'limit';
  if (balance.warningLimit > 0 && balance.balance > balance.warningLimit)
    return 'warning';
  return 'ok';
}
